export default __webpack_public_path__ + "static/media/work-mob-details.3116e33d.png";